export default {
	site_name: 'tm-wireframes',
};
